// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"f0a29354","276":"b1aac114","462":"8ce11780","515":"0ec530f4","713":"84ed7cc1"}[chunkId] + ".chunk.js";
};